import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import util from "../util/util";

export default function CampaignDetailRules(props) {
  const rules = props.rules || [];

  return (
    <div>
      <div className="row">
        <div className="col-xs-6">
          <h4 className="page__header">Rules</h4>
        </div>
        <div className="col-xs-6">
          <p className="page__actions">
            <Link
              to={util.returnRuleFormUrl(0, null, props.campaignId)}
              className="btn btn-primary"
            >
              <i className="fa fa-plus" aria-hidden="true"></i>
              Add to New Rule
            </Link>
          </p>
        </div>
      </div>

      <hr />

      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <colgroup>
            <col style={{ width: `1%` }}></col>
            <col style={{ width: `39%` }}></col>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `15%` }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>#</th>
              <th>Rule</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Time Slots / Shows</th>
              <th>Rule Created</th>
            </tr>
          </thead>
          <tbody>
            {rules.length === 0 ? (
              <tr>
                <td>
                  <strong>0</strong>
                </td>
                <td colSpan="5">{util.zeroRulesMessage}</td>
              </tr>
            ) : (
              rules.map((rule, index) => {
                const cleanedTimeSlots = util.returnCleanTimeSlots(
                  rule.timeslots
                );

                return (
                  <tr key={index}>
                    <td>
                      <strong>{index + 1}</strong>
                    </td>
                    <td>
                      <Link to={util.returnRuleDetailUrl(rule.id)}>
                        {rule.name}
                      </Link>
                    </td>
                    <td>
                      {moment(rule.start_date).format(util.dateFormatHumanLong)}
                    </td>
                    <td>
                      {moment(rule.end_date).format(util.dateFormatHumanLong)}
                    </td>
                    <td>
                      {rule.timeslots && rule.timeslots.length > 0 ? (
                        <span
                          className="timeslots-cell"
                          title={cleanedTimeSlots.join(`, `)}
                        >
                          {cleanedTimeSlots.join(`, `)}
                        </span>
                      ) : null}
                      {rule.shows && rule.shows.length > 0
                        ? util.renderShowsNames(rule.shows)
                        : null}
                    </td>
                    <td>
                      {moment(rule.created).format(util.dateFormatHumanLong)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {props.expired === false ? (
        <p className="text-center">
          <button
            id="campaign-detail-rules__load-expired"
            className="btn btn-default"
            onClick={props.onLoadExpired}
          >
            Load Expired Rules
          </button>
        </p>
      ) : null}
    </div>
  );
}

CampaignDetailRules.propTypes = {
  campaignId: PropTypes.number,
  expired: PropTypes.bool,
  rules: PropTypes.array,
  onLoadExpired: PropTypes.func
};
